export const GET_AUCTION_IDS = 'getAuctionIds';
export const GET_AUCTION_BY_ID = 'getAuctionById';
export const GET_VISIBLE_AUCTION_IDS = 'getVisibleAuctionIds';
export const GET_AUCTIONS_BY_COLLECTION_KEY = 'getAuctionsByCollectionKey';
export const GET_AUCTIONS_BY_COLLECTION_KEYS = 'getAuctionsByCollectionKeys';
export const HAS_SELECTED_AUCTION_LANE_SUB_FILTER = 'hasSelectedAuctionLaneSubFilter';
export const GET_AUCTION_VIA_VIEWING_AUCTION_MODEL = 'getAuctionViaViewingAuctionModel';
export const GET_SELECTED_AUCTION_LANE = 'getSelectedAuctionLane';
export const GET_SUBSCRIPTION_BY_AUCTION_ID = 'getSubscriptionByAuctionId';
